let layout = '<div class="col-md-7 col-xs-12 col col1"><a href="%%link%%" target="_blank" rel="noopener noreferrer">%%link%%</a></div>'
layout += '<div class="col-md-1 col-xs-3 col col2">%%frauen%%</div>'
layout += '<div class="col-md-1 col-xs-2 col col3">%%männer%%</div>'
layout += '<div class="col-md-1 col-xs-2 col col4">%%kinder%%</div>'
layout += '<div class="col-md-1 col-xs-2 col col5">%%bestager%%</div>'
layout += '<div class="col-md-1 col-xs-3 col col6">%%komparse%%</div>'

export default layout
